import React, {PropsWithChildren} from 'react';
import Carousel from 'shared/components/carousel';

const MiniInfoCardContainer = ({children}: PropsWithChildren) => (
  <Carousel className="mini-info-card-container">{children}</Carousel>
);

export default MiniInfoCardContainer;
